import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { Container } from 'reactstrap'

import TitleBar from '../../atoms/TitleBar'
import DownloadList from '../../organisms/DownloadList'

const ContainerStatic = styled(Container)`
  margin-top: 6rem;
  padding-bottom: 4rem;
`

const Downloads = ({ downloads }) => (
  <ContainerStatic>
    <TitleBar>
      download.page.title
    </TitleBar>
    <DownloadList
      downloads={ _.orderBy(downloads.list, ['value', 'id'], ['desc', 'desc']) }
    />
  </ContainerStatic>
)

export default Downloads



// WEBPACK FOOTER //
// ./src/components/templates/Downloads/Downloads.js